import { Action } from '@ngrx/store';
import { Params } from '@angular/router';

import { ErrorResponse, QueryOptions } from '~shared/models';
import { Filters } from '../../models';

export enum FiltersActionTypes {
  LOAD_FILTERS = '[Filters] Filters load',
  RESET_FILTERS = '[Filters] Filters reset',
  LOAD_FILTERS_SUCCESS = '[Filters] Filters load success',
  LOAD_FILTERS_FAILURE = '[Filters] Filters load failure'
}

export class LoadFilters implements Action {
  readonly type = FiltersActionTypes.LOAD_FILTERS;

  constructor(public payload: { filters: Params, queryParams: QueryOptions }) {
  }
}

export class ResetFilters implements Action {
  readonly type = FiltersActionTypes.RESET_FILTERS;

  constructor() {
  }
}

export class LoadFiltersSuccess implements Action {
  readonly type = FiltersActionTypes.LOAD_FILTERS_SUCCESS;

  constructor(public payload: { filters: Filters }) {
  }
}

export class LoadFiltersFailure implements Action {
  readonly type = FiltersActionTypes.LOAD_FILTERS_FAILURE;

  constructor(public payload: { error: ErrorResponse }) {
  }
}

export type FiltersActionsUnion = LoadFilters | ResetFilters|  LoadFiltersSuccess | LoadFiltersFailure;
